import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ContactoDto } from '@models/contacto/contactoDto.model';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-card-view-contactos-simple',
  templateUrl: './card-view-contactos-simple.component.html',
  styleUrls: ['./card-view-contactos-simple.component.css'],
  standalone: true,
  imports: [MatCardModule, MatButtonModule, CommonModule, NgxSpinnerModule, MatIconModule],
})
export class CardViewContactosSimpleComponent {
  @Input() contactos: ContactoDto[] = [];

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges() {
    this.cdr.detectChanges(); // fuerza actualización
  }
}
